function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import React, { useMemo } from "react";
export * from "./hooks";
export function toPx(value) {
  return Number.isFinite(value) ? "".concat(value, "px") : value;
}
export var sleep = function sleep(milliseconds) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, milliseconds);
  });
};
export var NumberFormat = new Intl.NumberFormat("en-us", {
  style: "currency",
  currency: "USD"
});
export function isValidNumber(number) {
  // disallow empty strings
  if (typeof number === "string" && number.trim() === "") {
    return false;
  }

  // disallow scientific notation
  if (typeof number === "string" && number.indexOf("e") !== -1) {
    return false;
  }
  try {
    var n = Number(number);
    return !Number.isNaN(n) && Number.isFinite(n);
  } catch (e) {
    return false;
  }
}
export var onKey = function onKey(key, callback, handler) {
  return function (event) {
    if (event.which === key) {
      event.preventDefault();
      callback(event);
    }
    if (handler) {
      handler(event);
    }
  };
};
export var onSpace = function onSpace(callback, handler) {
  return onKey(32, callback, handler);
};
export var onEnter = function onEnter(callback, handler) {
  return onKey(13, callback, handler);
};
export var useIcon = function useIcon(icon) {
  return useMemo(function () {
    if (icon === undefined) return null;
    var isRenderable = ["string", "number", "boolean"].includes(_typeof(icon));
    return isRenderable || /*#__PURE__*/React.isValidElement(icon) ? icon : /*#__PURE__*/React.createElement(icon);
  }, [icon]);
};
export var isIcon = function isIcon(node) {
  if (!node || _typeof(node) !== "object") return false;
  if (node.type === "svg") return true;
  if (typeof node.type === "function") {
    var fnStr = node.type.toString();
    return fnStr.includes("<svg") || fnStr.includes("createElement(\"svg\"");
  }
  return false;
};
export var onRadioKeyPress = function onRadioKeyPress(id) {
  return onSpace(function () {
    return document.querySelector("#".concat(id)).click();
  });
};
export var Sorting = /*#__PURE__*/function (Sorting) {
  Sorting[Sorting["Equal"] = 0] = "Equal";
  Sorting[Sorting["Greater"] = 1] = "Greater";
  Sorting[Sorting["Less"] = -1] = "Less";
  return Sorting;
}({});
export var TIMELINE_POSITION = /*#__PURE__*/function (TIMELINE_POSITION) {
  TIMELINE_POSITION["LEFT"] = "left";
  TIMELINE_POSITION["RIGHT"] = "right";
  TIMELINE_POSITION["ALTERNATE"] = "alternate";
  return TIMELINE_POSITION;
}({});
export var TIMELINE_VARIANT = /*#__PURE__*/function (TIMELINE_VARIANT) {
  TIMELINE_VARIANT["PRIMARY"] = "primary";
  TIMELINE_VARIANT["DESTRUCTIVE"] = "destructive";
  TIMELINE_VARIANT["CONFIRM"] = "confirm";
  TIMELINE_VARIANT["WHITE"] = "white";
  TIMELINE_VARIANT["SHOP"] = "shop";
  TIMELINE_VARIANT["NONE"] = "";
  return TIMELINE_VARIANT;
}({});
export function isTestEnv() {
  return (typeof process === "undefined" ? "undefined" : _typeof(process)) === "object" && process.env.NODE_ENV === "test";
}
export var MAX_OPTIONS_HEIGHT = 254;
var INPUT_HEIGHT = 38;
var BORDER_HEIGHT = 1;
export var MAX_RESULTS_BOX_HEIGHT = MAX_OPTIONS_HEIGHT + INPUT_HEIGHT + BORDER_HEIGHT * 2;
//# sourceMappingURL=index.js.map